import { GlobalApi } from '@Apis';
import { useOrgStore } from '@Models/useOrgModel';
import { useQuery } from '@tanstack/react-query';

export const useSocialGraphEnabledQuery = () => {
  const { orgId } = useOrgStore();
  const queryKey = ['socialGraphEnabled', orgId];
  return useQuery({
    queryKey,
    queryFn: () => GlobalApi.getSocialGraphSettingsEnabledStatus(),
    select: (res) => res.data,
    staleTime: Infinity,
  });
};
